import apiClient from '../auth/apiClient';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://167.71.62.249/';
const API_URL_LAB = BASE_URL + 'lab/';
const API_URL_AUTH = BASE_URL + 'auth/';

const getAnalyses = () => {
  return apiClient.get(API_URL_LAB + 'anal-list');
};

const getEndpoints = () => {
  return apiClient.get(API_URL_LAB + 'endpoints');
};

const getEndpointDetail = (id) => {
  return apiClient.get(API_URL_LAB + `endpoints/${id}`);
};

const getModels = () => {
  return apiClient.get(API_URL_LAB + 'mlmodels');
};

const getModelsArray = (ids = []) => {
  // Construct the query parameters for the ids
  const queryParams = ids.length ? `?${ids.map(id => `ids[]=${id}`).join('&')}` : '';

  return apiClient.get(`${API_URL_LAB}mlmodels-array/${queryParams}`);
};

const getMLModelsByEndpoint = (endpointId) => {
  return apiClient.get(`${API_URL_LAB}mlmodels/endpoint/${endpointId}`);
};

const getAnalysisDetail = (id) => {
  return apiClient.get(API_URL_LAB + `analysis/${id}`);
};

const deleteAnalysis = (id) => {
  return apiClient.delete(API_URL_LAB + `analysis/${id}/delete`, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

const getUserInfo = () => {
  return apiClient.get(API_URL_AUTH + 'user');
};

const startPrediction = (data) => {
  return apiClient.post(API_URL_LAB + 'start-pred', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

const getSelectModels = (pk) => {
  return apiClient.get(API_URL_LAB + `run-calc/${pk}`);
};

const runCalcPrediction = (pk, data) => {
  return apiClient.post(API_URL_LAB + `run-calc/${pk}`, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

const getModelDetails = (pk) => {
  return apiClient.get(API_URL_LAB + `mlmodels/${pk}`);
};

const getSmilesImage = (pk) => {
  return apiClient.get(API_URL_LAB + `analysis-image/${pk}`);
};

const getSmilesImage2 = (pk) => {
  return apiClient.get(API_URL_LAB + `analysis-image2/${pk}`);
};

const getSmilesImageList = (smilesList) => {
  return apiClient.post(
    API_URL_LAB + 'generate-images/',
    { smiles_list: smilesList },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
};

const getLeveragePlot = (pk) => {
  return apiClient.get(API_URL_LAB + `leverage-plot/${pk}`);
};

const checkComputationStatus = (pk) => {
  return apiClient.get(API_URL_LAB + `computation-status/${pk}`);
};

const contactUs = (data) => {
    return apiClient.post(API_URL_AUTH + 'contact-us/', data);
};

const redeemCoupon = (code) => {
  return apiClient.post(API_URL_LAB + 'redeem-coupon/', { code });
};
const downloadReportsZip = (pk) => {
  return apiClient.get(API_URL_LAB + `analysis/${pk}/download-reports/`, {
    responseType: 'blob', // BARDZO WAŻNE DLA POBIERANIA PLIKÓW!
  });
};

export default {
  getAnalyses,
  getAnalysisDetail,
  deleteAnalysis,
  getUserInfo,
  startPrediction,
  getSelectModels,
  runCalcPrediction,
  getModelDetails,
  getSmilesImage,
  getSmilesImage2,
  checkComputationStatus,
  getEndpoints,
  getEndpointDetail,
  getMLModelsByEndpoint,
  getModels,
  getModelsArray,
  getSmilesImageList,
  getLeveragePlot,
  contactUs,
  redeemCoupon,
  downloadReportsZip
};
